import React from 'react';


function Breadcrumb() {
  return (
    <div className="breadcrumb-wrapper py-3 px-3">
      <div className="container">
        <h2 className="breadcrumb-title">Renewable Energy in India</h2>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb custom-breadcrumb mb-0">
            <li className="breadcrumb-item">
              <a href="/" className="breadcrumb-link">Home</a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Renewable Energy in India
            </li>
          </ol>
        </nav>
      </div>
    </div>
  );
}

export default Breadcrumb;
